import Vue from "vue";
import VueRouter from "vue-router";

import SmpDataList from "../views/SmpData/SmpDataList.vue";
import SmpDataAdd from "../views/SmpData/SmpDataAdd.vue";
import SmpDataEdit from "../views/SmpData/SmpDataEdit.vue";

import Overview from "../views/Overview/Overview.vue";
import OverviewDetails from "../views/Overview/Details.vue";
import Location from "../views/Location/Location.vue";
import AlertList from "../views/Alert/AlertList.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  board: process.env.BOARD_URL,
  routes: [
    {
      path: "/",
      name: "Overview",
      component: Overview,
    },
    {
      path: "/details/:id",
      name: "Overview Details",
      component: OverviewDetails,
    },
    {
      path: "/smp-data",
      name: "SMP Data List",
      component: SmpDataList,
    },
    {
      path: "/smp-data/add",
      name: "SMP Data Add",
      component: SmpDataAdd,
    },
    {
      path: "/smp-data/edit/:id",
      name: "SMP Data Edit",
      component: SmpDataEdit,
    },
    {
      path: "/location",
      name: "Location",
      component: Location,
    },
    {
      path: "/alert",
      name: "Alert",
      component: AlertList,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (
      router.app.$keycloak.authenticated &&
      router.app.$keycloak.hasRealmRole("admin")
    ) {
      next();
    } else {
      if (router.app.$keycloak.authenticated) router.app.$keycloak.logoutFn();
      else {
        const loginUrl = router.app.$keycloak.createLoginUrl();
        window.location.replace(loginUrl);
      }
    }
  } else {
    next();
  }
});

export default router;
